/* Real Shopify Cart; medical details remain in Shopify line properties only. */
(function () {
  'use strict';
  const route = path => (window.Shopify?.routes?.root || '/') + path;
  async function request(path, body) {
    const response = await fetch(route(path), {method:body?'POST':'GET', headers:body?{'Content-Type':'application/json'}:{}, body:body?JSON.stringify(body):undefined, cache:'no-store'});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please retry.');
    return data;
  }
  function groups(cart) {
    const result = [], pairs = new Map();
    for (const item of cart.items) {
      const reference = item.properties?.['Pair reference'];
      if (!reference) {result.push({reference:null,frame:item,lines:[item],quantity:item.quantity});continue;}
      if (!pairs.has(reference)) pairs.set(reference, []);
      pairs.get(reference).push(item);
    }
    for (const [reference,lines] of pairs) {
      const frame=lines.find(item=>item.properties['Pair component']==='Eyewear');
      const lens=lines.find(item=>item.properties['Pair component']==='Direct prescription lenses');
      const valid=lines.length===2 && frame && lens && frame.quantity===lens.quantity &&
        String(frame.variant_id)===lens.properties['Eyewear variant'] &&
        lines.every(item=>item.properties['_rx_components']==='2' && item.properties['Prescription route']==='Direct Rx');
      result.push({reference,frame:frame||lines[0],lens,lines,quantity:frame?.quantity||lines[0].quantity,valid:!!valid});
    }
    return result;
  }
  let pending = false;
  window.ERNativeCart = {
    groups, read:()=>request('cart.js'),
    async quantity(reference, key, quantity) {
      if (pending) throw new Error('A cart update is in progress. Please wait.');
      if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 99) throw new Error('Choose a quantity from 1 to 99.');
      pending=true;
      try {
        const before=await request('cart.js');
        const group=groups(before).find(item=>reference?item.reference===reference:item.frame.key===key);
        if (!group) throw new Error('Your cart changed. Reload it before continuing.');
        if (reference && !group.valid && quantity!==0) throw new Error('This pair is incomplete. Remove it and select your lenses again.');
        const updates=Object.fromEntries(group.lines.map(item=>[item.key,quantity]));
        const after=await request('cart/update.js',{updates});
        const remaining=groups(after).find(item=>reference?item.reference===reference:item.frame.key===key);
        if (quantity===0 ? !!remaining : (!remaining || remaining.quantity!==quantity || (reference && !remaining.valid)))
          throw new Error('The complete pair could not be confirmed. Review your cart before checkout.');
        return after;
      } finally {pending=false;}
    },
    async discounts(codes) {
      if(pending)throw new Error('A cart update is in progress. Please wait.');
      if(!Array.isArray(codes)||codes.length>5||codes.some(code=>typeof code!=='string'||!code.trim()||code.length>255||code.includes(',')))throw new Error('Enter one valid coupon code at a time.');
      pending=true;
      try {return await request('cart/update.js',{discount:[...new Set(codes.map(code=>code.trim().toUpperCase()))].join(',')});}
      finally {pending=false;}
    },
    async checkout() {
      if (pending) throw new Error('Wait for your cart update to finish.');
      const cart=await request('cart.js');
      if (!cart.items.length) throw new Error('Your cart is empty.');
      if (groups(cart).some(item=>item.reference && !item.valid)) throw new Error('A prescription pair is incomplete. Remove it and select lenses again before checkout.');
      // Shopify owns checkout, payment, taxes and delivery; no local order creation.
      const form=document.createElement('form');form.method='post';form.action=route('cart');
      const input=document.createElement('input');input.type='hidden';input.name='checkout';input.value='Checkout';
      form.append(input);document.body.append(form);
      window.ERPurchaseNavigation?.checkoutIntent(null,'cart_page');
      window.ERPurchaseNavigation?.checkoutDispatched(false);
      form.submit();
    }
  };
})();
